import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-dropdown', 'openLang', 'Открыть выбор языка');
Labels.set('ui-dropdown', 'countryCode', 'Код страны');
Labels.set('ui-dropdown', 'listboxName', 'Доступные варианты');

Labels.set('ui-dropdown', 'eng', 'Английский');
Labels.set('ui-dropdown', 'est', 'Эстонский');
Labels.set('ui-dropdown', 'lat', 'Латышский');
Labels.set('ui-dropdown', 'lit', 'Литовский');
Labels.set('ui-dropdown', 'rus', 'Русский');
